module.exports = __webpack_public_path__ + "static/karolina-maliszewska-medinvest-a609d59189f7bd3cb6cc7b86140b4f25.jpg";